import { DEVICE_LINKING } from '../../constants/device-linking';
import LinkCodeDisplay from './LinkCodeDisplay';

type Props = {
  linkCode: string;
  copied: boolean;
  isGenerating: boolean;
  isAtLimit: boolean;
  onGenerate: () => void;
  onCopy: () => void;
};

export default function GenerateLinkCodeSection({
  linkCode,
  copied,
  isGenerating,
  isAtLimit,
  onGenerate,
  onCopy,
}: Props) {
  return (
    <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-gray-50 rounded-lg">
      <h3 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3 text-gray-900">
        Generate Link Code
      </h3>
      <p className="text-base text-gray-600 mb-3 sm:mb-4">
        Generate a {DEVICE_LINKING.CODE_LENGTH}-digit code on this device and
        enter it on your other device.
      </p>

      {isAtLimit && (
        <div className="mb-3 sm:mb-4 p-2 sm:p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-base">
          Maximum of {DEVICE_LINKING.MAX_DEVICES} devices can be linked. Unlink
          a device to link a new one.
        </div>
      )}

      {linkCode ? (
        <LinkCodeDisplay linkCode={linkCode} copied={copied} onCopy={onCopy} />
      ) : (
        <button
          onClick={onGenerate}
          disabled={isGenerating || isAtLimit}
          className="w-full px-4 py-2.5 sm:py-3 bg-green-700 text-white rounded-lg hover:bg-green-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium text-base">
          {isGenerating ? 'Generating...' : 'Generate Link Code'}
        </button>
      )}
    </div>
  );
}
